import { LogoLetter } from "@assets/icons/LogoLetter";
import phones from "@assets/images/phones.png";
import ToggleSwitch from "@components/Home/ToggleSwitchLang/ToggleSwitchLang";
import { yupResolver } from "@hookform/resolvers/yup";
import AddIcon from "@mui/icons-material/Add";
import {
  Box,
  Button,
  Grid,
  Link,
  Stack,
  TextField,
  Typography,
} from "@mui/material";
import React, { useEffect, useState } from "react";
import { useForm } from "react-hook-form";
import { useTranslation } from "react-i18next";
import { useLocation, useNavigate } from "react-router-dom";
import { useRegisterMutation } from "store/auth/auth.api";
import * as yup from "yup";
import "./register.scss";
import {
  StyledBox,
  StyledBoxLeft,
  StyledIconButton,
  TitleSignup,
} from "./Register.style";
import { toast } from "react-toastify";

const Register = () => {
  const location = useLocation();
  const navigate = useNavigate();
  const [errorMsg, setErrorMsg] = useState("");

  const { t } = useTranslation();

  const packId = location.state?.packId;
  console.log("🚀 ~ Register ~ packId:", packId);
  const packPrice = location.state?.packPrice;
  useEffect(() => {
    if (!packId) {
      navigate("/");
    }
  }, [packId, navigate]);

  const [registerMutation, { isLoading, error }] = useRegisterMutation();

  useEffect(() => {
    if (error) {
      const message = error?.data?.message || "Erreur lors de l'inscription";
      setErrorMsg(message);
      toast.error(message); // ✅ Show toast right here, not in cleanup
    }
  }, [error]);

  const [kbisFile, setKbisFile] = useState(null);
  const [urssaf, setUrssaf] = useState(null);
  const [fiscale, setFiscale] = useState(null);
  const [rcPro, setRcPro] = useState(null);

  const [extraFiles, setExtraFiles] = useState([]);

  const schema = yup.object().shape({
    email: yup.string().email().required(t("register.email_required")),
    name: yup.string().required(t("register.company_name_required")),
    ownerName: yup.string().required(t("register.owner_name_required")),
    phone: yup.number().required(t("register.phone_required")),
    kbis: yup.mixed().required(t("register.kbis_required")),
    address: yup.string().required(t("register.address_required")),
  });

  const {
    handleSubmit,
    register,
    formState: { errors },
    setValue,
  } = useForm({
    resolver: yupResolver(schema),
  });

  const handleExtraFileChange = (index, file) => {
    const updated = [...extraFiles];
    updated[index].file = file;
    setExtraFiles(updated);
  };

  const handleExtraTitleChange = (index, title) => {
    const updated = [...extraFiles];
    updated[index].title = title;
    setExtraFiles(updated);
  };

  const onSubmit = async (data) => {
    const formData = new FormData();
    formData.append("email", data.email);
    formData.append("password", "password");
    formData.append("packId", packId);
    formData.append("name", data.name);
    formData.append("ownerName", data.ownerName);
    formData.append("phone", data.phone);
    formData.append("kbis", data.kbis);
    formData.append("address", data.address);

    if (urssaf) formData.append("urssaf", urssaf);
    if (fiscale) formData.append("fiscale", fiscale);
    if (rcPro) formData.append("rcPro", rcPro);

    extraFiles.forEach((item) => {
      if (item.file) {
        formData.append("extraFiles", item.file); // ✅ c’est OK d’envoyer plusieurs fichiers sous la même clé
      }
      if (item.title) {
        formData.append("extraFilesTitles", item.title); // ✅ idem ici
      }
    });
    for (const [key, value] of formData.entries()) {
      console.log(`${key}:`, value);
    }

    try {
      await registerMutation(formData).unwrap();
      navigate("/payment", { state: { ...data, packId, packPrice } });
    } catch (error) {
      console.error("Erreur lors de l’inscription:", error);
    }
  };

  return (
    <Grid container sx={{ height: "130vh" }}>
      {!packId && (
        <Stack className="alert-packId">{t("register.alert_pack")}</Stack>
      )}{" "}
      <Grid
        item
        xs={12}
        md={6}
        lg={5}
        sx={{ backgroundColor: "#F6F6FA", p: 4, textAlign: "center" }}>
        <LogoLetter />
        <Typography variant="h5" fontWeight="bold" mt={4}>
          Factures
          <span style={{ color: "#0F84FF" }}>
            {t("register.title").split(" ")[0]}
          </span>{" "}
          et{" "}
          <span style={{ color: "#0F84FF" }}>
            {t("register.title").split(" ")[1]}
          </span>
        </Typography>
        <Box mt={4}>
          <img
            src={phones}
            alt="Phones"
            width={"100%"}
            style={{ maxWidth: 430 }}
          />
        </Box>
      </Grid>
      <Grid
        item
        xs={12}
        md={6}
        lg={7}
        sx={{
          backgroundColor: "#fff",
          p: 8,
          display: "flex",
          alignItems: "center",
          justifyContent: "center",
        }}>
        <Box width="100%">
          <ToggleSwitch />
          <TitleSignup>{t("register.title")}</TitleSignup>
          <Box sx={{ display: "flex", gap: 1 }}>
            <div
              className="line-inscription"
              style={{
                width: "50%",
                height: "9px",
                borderRadius: "46px",
                background: "#0F84FF",
                marginBottom: "2rem",
              }}></div>
            <div
              className="line-inscription"
              style={{
                width: "50%",
                height: "9px",
                borderRadius: "46px",
                background: "#E7E7E8",
                marginBottom: "2rem",
              }}></div>
          </Box>

          <form onSubmit={handleSubmit(onSubmit)} noValidate>
            <Box sx={{ maxWidth: "800px", mx: "auto" }}>
              <Grid container spacing={2}>
                <StyledBox>
                  <Grid item xs={12} md={6} className="input-register">
                    <TextField
                      label={t("register.email_label")}
                      variant="standard"
                      fullWidth
                      {...register("email")}
                      error={!!errors.email}
                      helperText={errors.email?.message}
                    />
                  </Grid>
                </StyledBox>

                <StyledBox>
                  <Grid item xs={12} md={6} className="input-register">
                    <TextField
                      label={t("register.address_label")}
                      variant="standard"
                      fullWidth
                      {...register("address")}
                      error={!!errors.address}
                      helperText={errors.address?.message}
                    />
                  </Grid>
                  <Grid item xs={12} md={6} className="input-register">
                    <TextField
                      label={t("register.company_name_label")}
                      variant="standard"
                      fullWidth
                      {...register("name")}
                      error={!!errors.name}
                      helperText={errors.name?.message}
                    />
                  </Grid>
                </StyledBox>

                <StyledBox>
                  <Grid item xs={12} md={6} className="input-register">
                    <TextField
                      label={t("register.owner_name_label")}
                      variant="standard"
                      fullWidth
                      {...register("ownerName")}
                      error={!!errors.ownerName}
                      helperText={errors.ownerName?.message}
                    />
                  </Grid>
                  <Grid item xs={12} md={6} className="input-register">
                    <TextField
                      label={t("register.phone_label")}
                      variant="standard"
                      fullWidth
                      {...register("phone")}
                      error={!!errors.phone}
                      helperText={errors.phone?.message}
                    />
                  </Grid>
                </StyledBox>

                <StyledBox>
                  <Grid item xs={12} md={6} className="input-register">
                    <Button
                      variant="outlined"
                      component="label"
                      fullWidth
                      sx={{ textAlign: "left" }}>
                      {kbisFile ? kbisFile.name : t("register.kbis_label")}
                      <input
                        type="file"
                        hidden
                        accept=".pdf,.jpg,.png"
                        onChange={(e) => {
                          const file = e.target.files[0];
                          setKbisFile(file);
                          setValue("kbis", file);
                        }}
                      />
                    </Button>
                    {errors.kbis && (
                      <Typography color="error" variant="caption">
                        {errors.kbis.message}
                      </Typography>
                    )}
                  </Grid>
                </StyledBox>

                <StyledBox gap={4}>
                  <Grid item xs={12} sm={6} md={3} className="input-register">
                    <Button
                      variant="outlined"
                      component="label"
                      fullWidth
                      sx={{ textAlign: "left" }}>
                      {urssaf ? urssaf.name : t("register.urssaf_label")}
                      <input
                        type="file"
                        hidden
                        onChange={(e) => setUrssaf(e.target.files[0])}
                      />
                    </Button>
                  </Grid>
                  <Grid item xs={12} sm={6} md={3} className="input-register">
                    <Button
                      variant="outlined"
                      component="label"
                      fullWidth
                      sx={{ textAlign: "left" }}>
                      {fiscale ? fiscale.name : t("register.fiscale_label")}
                      <input
                        type="file"
                        hidden
                        onChange={(e) => setFiscale(e.target.files[0])}
                      />
                    </Button>
                  </Grid>
                  <Grid item xs={12} sm={6} md={3} className="input-register">
                    <Button
                      variant="outlined"
                      component="label"
                      fullWidth
                      sx={{ textAlign: "left" }}>
                      {rcPro ? rcPro.name : "RC Pro"}
                      <input
                        type="file"
                        hidden
                        onChange={(e) => setRcPro(e.target.files[0])}
                      />
                    </Button>
                  </Grid>
                </StyledBox>

                {extraFiles.map((item, index) => (
                  <StyledBox key={index}>
                    <Grid item xs={12} md={6} className="input-register">
                      <TextField
                        label={t("register.title_file")}
                        variant="standard"
                        fullWidth
                        value={item.title}
                        onChange={(e) =>
                          handleExtraTitleChange(index, e.target.value)
                        }
                      />
                    </Grid>
                    <Grid item xs={12} md={6} className="input-register">
                      <Button
                        variant="outlined"
                        component="label"
                        fullWidth
                        sx={{ textAlign: "left" }}>
                        {item.file
                          ? item.file.name
                          : t("register.fichier_label")}
                        <input
                          type="file"
                          hidden
                          onChange={(e) =>
                            handleExtraFileChange(index, e.target.files[0])
                          }
                        />
                      </Button>
                    </Grid>
                  </StyledBox>
                ))}

                <Box mt={2} ml={1}>
                  <StyledIconButton
                    sx={{}}
                    onClick={() =>
                      setExtraFiles([...extraFiles, { title: "", file: null }])
                    }>
                    {t("register.addFile")} <AddIcon color="primary" />
                  </StyledIconButton>
                </Box>
              </Grid>
            </Box>

            <StyledBoxLeft>
              <Box
                display="flex"
                alignItems="center"
                gap={1}
                sx={{
                  flexDirection: { xs: "column", sm: "column", md: "row" },
                }}>
                <Typography variant="body2">
                  {t("register.already_account")}
                </Typography>
                <Link href="/login" underline="none" sx={{ color: "#0F84FF" }}>
                  {t("register.login")}
                </Link>
              </Box>

              <Button
                type="submit"
                fullWidth
                variant="contained"
                sx={{
                  backgroundColor: "#0F84FF",
                  color: "white",
                  width: "40%",
                  margin: "2rem auto",
                }}
                disabled={isLoading}>
                {isLoading ? t("register.loading") : t("register.next")}
              </Button>
            </StyledBoxLeft>
          </form>
        </Box>
      </Grid>
    </Grid>
  );
};

export default Register;
